"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _isNan = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/number/is-nan"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _messages = require("./messages");
/* eslint-disable no-console */

var ANONYMOUS = '<<anonymous>>';
var domElement = function domElement() {
  // Element is not defined unless the Browser API is defined
  if (typeof Element === 'undefined') {
    return _propTypes.default.any;
  }
  return _propTypes.default.instanceOf(Element);
};
var elementOrArrayOfElements = function elementOrArrayOfElements() {
  return _propTypes.default.oneOfType([_propTypes.default.arrayOf(domElement()), domElement()]);
};
function newAssign(target) {
  var _arguments = arguments;
  var newTarget = target;
  var _loop = function _loop() {
    // eslint-disable-next-line prefer-rest-params
    var source = _arguments[i];
    (0, _keys.default)(source).forEach(function (key) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        newTarget[key] = source[key];
      }
    });
  };
  for (var i = 1; i < arguments.length; i += 1) {
    _loop();
  }
  return newTarget;
}
var wrapValidator = function wrapValidator(validator, typeName) {
  var typeChecker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return newAssign(validator.bind(), {
    typeName: typeName,
    typeChecker: typeChecker,
    isRequired: newAssign(validator.isRequired.bind(), {
      typeName: typeName,
      typeChecker: typeChecker,
      typeRequired: true
    })
  });
};
var createChainableTypeChecker = function createChainableTypeChecker(validate) {
  var checkType = function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var safeComponentName = componentName || ANONYMOUS;
    var safePropFullName = propFullName || propName;
    var value = props[propName];
    if (typeof value === 'undefined' || value === null) {
      if (isRequired) {
        var _context, _context2, _context3;
        return new TypeError((0, _concat.default)(_context = (0, _concat.default)(_context2 = (0, _concat.default)(_context3 = "The ".concat(location, " `")).call(_context3, safePropFullName, "` is marked as required in `")).call(_context2, safeComponentName, "`, but its value is `")).call(_context, value === null ? 'null' : (0, _typeof2.default)(value), "`."));
      }
      return null;
    }
    return validate(props, propName, safeComponentName, location, safePropFullName);
  };
  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
};
var range = function range(min, max) {
  if ((0, _isNan.default)(min)) {
    console.error('The `min` parameter supplied to the `range` propType is required and must be a `number`.');
    return function () {
      return null;
    };
  }
  if ((0, _isNan.default)(max)) {
    console.error('The `max` parameter supplied to the `range` propType is required and must be a `number`.');
    return function () {
      return null;
    };
  }
  if (min >= max) {
    console.error('In the `range` propType, the `min` value must be less than the `max` value.');
    return function () {
      return null;
    };
  }
  var validate = function validate(props, propName, componentName, location, propFullName) {
    // eslint-disable-next-line react/destructuring-assignment
    var value = props[propName];

    // If no value is provided, don't fail validation.
    if (typeof value === 'undefined' || value === null) {
      return null;
    }
    if ((0, _isNan.default)(value)) {
      var _context4, _context5, _context6;
      return new TypeError((0, _concat.default)(_context4 = (0, _concat.default)(_context5 = (0, _concat.default)(_context6 = "Invalid ".concat(location, " `")).call(_context6, propFullName, "` of type `")).call(_context5, (0, _typeof2.default)(value), "` supplied to `")).call(_context4, componentName, "`, expected `number`."));
    }
    if (value < min || value > max) {
      var _context7, _context8, _context9, _context10, _context11;
      return new Error((0, _concat.default)(_context7 = (0, _concat.default)(_context8 = (0, _concat.default)(_context9 = (0, _concat.default)(_context10 = (0, _concat.default)(_context11 = "The ".concat(location, " `")).call(_context11, propFullName, "` supplied to `")).call(_context10, componentName, "` has a value of `")).call(_context9, value, "`, which is not in the range `")).call(_context8, min, "` to `")).call(_context7, max, "` (inclusive)."));
    }
    return null;
  };
  return wrapValidator(createChainableTypeChecker(validate), 'range', {
    min: min,
    max: max
  });
};
var localizedString = function localizedString(id) {
  var validate = function validate(props, propName, componentName, location, propFullName) {
    // eslint-disable-next-line react/destructuring-assignment
    var value = props[propName];
    if (!value) {
      var _context12, _context13, _context14;
      return new Error((0, _concat.default)(_context12 = (0, _concat.default)(_context13 = (0, _concat.default)(_context14 = "The ".concat(location, " `")).call(_context14, propFullName, "` was not supplied to `")).call(_context13, componentName, "`. ")).call(_context12, (0, _messages.LOCALIZED_TEXT_MESSAGE)(id)));
    }
    if (typeof value !== 'string') {
      var _context15, _context16;
      return new Error((0, _concat.default)(_context15 = (0, _concat.default)(_context16 = "The ".concat(location, " `")).call(_context16, propFullName, "` must be a string. ")).call(_context15, (0, _messages.LOCALIZED_TEXT_MESSAGE)(id)));
    }
    return null;
  };
  return wrapValidator(createChainableTypeChecker(validate), 'localizedString', id);
};
var localizedStringOrFunction = function localizedStringOrFunction(id) {
  var validate = function validate(props, propName, componentName, location, propFullName) {
    // eslint-disable-next-line react/destructuring-assignment
    var value = props[propName];
    if (!value) {
      var _context17, _context18, _context19;
      return new Error((0, _concat.default)(_context17 = (0, _concat.default)(_context18 = (0, _concat.default)(_context19 = "The ".concat(location, " `")).call(_context19, propFullName, "` was not supplied to `")).call(_context18, componentName, "`. ")).call(_context17, (0, _messages.LOCALIZED_TEXT_MESSAGE)(id)));
    }
    if (typeof value !== 'string' && typeof value !== 'function') {
      var _context20, _context21;
      return new Error((0, _concat.default)(_context20 = (0, _concat.default)(_context21 = "The ".concat(location, " `")).call(_context21, propFullName, "` must be a string or a function. ")).call(_context20, (0, _messages.LOCALIZED_TEXT_MESSAGE)(id)));
    }
    return null;
  };
  return wrapValidator(createChainableTypeChecker(validate), 'localizedStringOrFunction', id);
};
var i18n = function i18n(obj) {
  if (!obj) {
    console.error('The shape parameter supplied to the `i18n` propType is required.');
    return function () {
      return null;
    };
  }
  var validate = function validate(props, propName, componentName, location, propFullName) {
    var _context24, _context25;
    // eslint-disable-next-line react/destructuring-assignment
    var value = props[propName];
    if (!value) {
      var _context22, _context23;
      return new Error((0, _concat.default)(_context22 = (0, _concat.default)(_context23 = "The ".concat(location, " `")).call(_context23, propFullName, "` was not supplied to `")).call(_context22, componentName, "`."));
    }
    var shapeKeys = (0, _keys.default)(obj);
    var valueKeys = (0, _keys.default)(value);
    var shapeKeysMismatch = (0, _filter.default)(shapeKeys).call(shapeKeys, function (key) {
      return !valueKeys.some(function (k) {
        return key === k;
      });
    });
    var valueKeysMismatch = (0, _filter.default)(valueKeys).call(valueKeys, function (key) {
      return !shapeKeys.some(function (k) {
        return key === k;
      });
    });
    var shapeKeysString = (0, _map.default)(shapeKeysMismatch).call(shapeKeysMismatch, function (key) {
      return "`".concat(key, "`");
    }).join(', ');
    var valueKeysString = (0, _map.default)(valueKeysMismatch).call(valueKeysMismatch, function (key) {
      return "`".concat(key, "`");
    }).join(', ');
    var introString = (0, _concat.default)(_context24 = (0, _concat.default)(_context25 = "The ".concat(location, " `")).call(_context25, propFullName, "` supplied to `")).call(_context24, componentName, "`");
    if (valueKeys.length < shapeKeys.length && !valueKeysString) {
      var _context26, _context27, _context28;
      return new Error((0, _concat.default)(_context26 = (0, _concat.default)(_context27 = (0, _concat.default)(_context28 = "".concat(introString, " has ")).call(_context28, valueKeys.length, " strings when it expected ")).call(_context27, shapeKeys.length, ". Missing ")).call(_context26, shapeKeysString, "."));
    }
    if (valueKeys.length > shapeKeys.length && !shapeKeysString) {
      var _context29;
      return new Error((0, _concat.default)(_context29 = "".concat(introString, " has extra keys: ")).call(_context29, valueKeysString, "."));
    }
    if (shapeKeysMismatch.length) {
      var _context30, _context31;
      return new Error((0, _concat.default)(_context30 = (0, _concat.default)(_context31 = "".concat(introString, " is missing: ")).call(_context31, shapeKeysString, ".  It has extra keys: ")).call(_context30, valueKeysString, "."));
    }
    if (valueKeysMismatch.length) {
      var _context32, _context33;
      return new Error((0, _concat.default)(_context32 = (0, _concat.default)(_context33 = "".concat(introString, " has extra keys: ")).call(_context33, valueKeysString, ".  It expects: ")).call(_context32, shapeKeysString, "."));
    }
    return null;
  };
  return wrapValidator(createChainableTypeChecker(validate), 'i18n', obj);
};
var arrayOfTupleTypes = function arrayOfTupleTypes(propType) {
  return function (props, propName, componentName) {
    // eslint-disable-next-line react/destructuring-assignment
    if (!Array.isArray(props[propName])) {
      var _context34;
      return new Error((0, _concat.default)(_context34 = "Invalid property ".concat(propName, " supplied to ")).call(_context34, componentName, " needs to be an array."));
    }

    // eslint-disable-next-line consistent-return, react/destructuring-assignment
    (0, _from.default)(props[propName]).forEach(function (innerProp) {
      if (!Array.isArray(innerProp) || innerProp.length !== 2) {
        var _context35;
        return new Error((0, _concat.default)(_context35 = "Invalid property ".concat(propName, " supplied to ")).call(_context35, componentName, " needs to be an array of arrays with length 2."));
      }
      _propTypes.default.checkPropTypes((0, _defineProperty2.default)({}, "".concat(propName, "[0]"), propType), (0, _defineProperty2.default)({}, "".concat(propName, "[0]"), innerProp[0]), "".concat(propName, "[0]"), componentName);
      _propTypes.default.checkPropTypes((0, _defineProperty2.default)({}, "".concat(propName, "[1]"), propType), (0, _defineProperty2.default)({}, "".concat(propName, "[1]"), innerProp[1]), "".concat(propName, "[1]"), componentName);
    });
    return null;
  };
};
var conditionallyRequired = function conditionallyRequired(propType, condition, conditionMessage) {
  return function (props, propName, componentName) {
    // eslint-disable-next-line react/destructuring-assignment
    if (condition(props) && !props[propName]) {
      var _context36, _context37;
      return new Error((0, _concat.default)(_context36 = (0, _concat.default)(_context37 = "The prop `".concat(propName, "` is required in `")).call(_context37, componentName, "` when ")).call(_context36, conditionMessage, "."));
    }

    // eslint-disable-next-line react/destructuring-assignment
    _propTypes.default.checkPropTypes((0, _defineProperty2.default)({}, "".concat(propName), propType), (0, _defineProperty2.default)({}, "".concat(propName), props[propName]), propName, componentName);
    return null;
  };
};
var notDefined = function notDefined() {
  return null;
};
var _default = {
  arrayOfTupleTypes: arrayOfTupleTypes,
  conditionallyRequired: conditionallyRequired,
  domElement: domElement,
  elementOrArrayOfElements: elementOrArrayOfElements,
  i18n: i18n,
  range: range,
  localizedString: localizedString,
  localizedStringOrFunction: localizedStringOrFunction,
  notDefined: notDefined
};
exports.default = _default;